const getValue = (item) => (key) => {
  let value = key === 'externalId' ? item.studentExternalId : item[key];

  // convert en dash to minus so that this char is displayed properly on CSV
  if (typeof value === 'string') {
    value = value.replace('−', '-');
  }

  if (typeof value === 'string' && value.includes(',')) {
    return `"${value}"`;
  }
  return value;
};

const jsToCsv = (columns, data) =>
  data.reduce((accum, item) => {
    const row = columns.map(getValue(item)).join(',');

    return `${accum}\r\n${row}`;
  }, columns.join(','));

export default jsToCsv;
